import React from 'react';
import { MdOutlineToday } from "react-icons/md";
import { NavLink, useLocation } from 'react-router-dom';
import { IoTodaySharp } from "react-icons/io5";

import './layout.css';

const EditAtdLayout = ({ children, userId }) => {
  const location = useLocation();

  if (!userId) {
    console.error("userId is undefined! Make sure to pass the userId prop.");
  }

  return (
    <div>
      <h1 className="layouts-title">
        <IoTodaySharp className="leave-policy-icon" />
        Today Attendance
      </h1>
      <hr />
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="current-date-link"
                className={({ isActive }) =>
                  `nav-link ${
                    isActive || location.pathname === `/current-month-atd/${userId}` ? 'active' : ''
                  }`
                }
                to={userId ? `/current-month-atd/${userId}` : "#"} // Safe fallback
              >
                <MdOutlineToday className="nav-icon" /> Current Month
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="content">{children}</div>
      </section>
    </div>
  );
};

export default EditAtdLayout;
